import React, { useContext, useEffect, useMemo, useState } from "react";
import { Image } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { GlobalStateContext } from "../GlobalStates";
import hambergerIcon from "../../asset/icons/hambergerIcon.svg";
import { Notification } from "iconsax-react";
import { useTranslation } from "react-i18next";
import NotificationsCenter from "../../features/incentives/NotificationsCenter";
import useSideBarList from "../../hooks/helperData/useSideBarList";
import useUserSideBarList from "../../hooks/helperData/useUserSideBarList";
import "./style.scss";

const APP_TITLE = "فیدیما";

const normalizePath = (path) => (path || "").replace(/\/+$/, "") || "/";

function resolveHeaderCrumb(pathname, organList, userList, t) {
    const path = normalizePath(pathname);
    const extras = [
        {
            matchLink: "/dashboard/food",
            addressLink: "/dashboard/sales/1",
            title: t("SalesAndServices.Label"),
            panel: "organ",
        },
        {
            matchLink: "/dashboard/market",
            addressLink: "/dashboard/sales/1",
            title: t("SellingCart.Label"),
            panel: "organ",
        },
        {
            matchLink: "/dashboard/sales",
            addressLink: "/dashboard/sales/1",
            title: t("SalesAndServices.Label"),
            panel: "organ",
        },
        {
            matchLink: "/dashboard/report",
            addressLink: "/dashboard/",
            title: t("reports.title"),
            panel: "organ",
        },
    ];

    const candidates = [
        ...userList.map((item) => ({ ...item, panel: "user" })),
        ...organList.map((item) => ({ ...item, panel: "organ" })),
        ...extras,
    ]
        .map((item) => ({
            ...item,
            link: normalizePath(item.matchLink || item.addressLink),
            href: item.addressLink,
        }))
        .sort((a, b) => b.link.length - a.link.length);

    const match = candidates.find((item) => {
        if (item.link === "/dashboard") {
            return path === "/dashboard";
        }
        return path === item.link || path.startsWith(`${item.link}/`);
    });

    if (!match) {
        return { panelType: "", panelName: "", pageHref: "", panelHref: "" };
    }

    const isUserPanel = match.panel === "user";

    return {
        panelType: isUserPanel
            ? t("User.Portal.label")
            : t("Corpration.Panel.label"),
        panelName: match.title,
        pageHref: match.href || match.link,
        panelHref: isUserPanel
            ? "/dashboard/user/dashboard"
            : "/dashboard/",
    };
}

function CrumbLink({ to, className, current, children }) {
    if (!to) {
        return <span className={className}>{children}</span>;
    }

    return (
        <Link
            to={to}
            className={className}
            aria-current={current ? "page" : undefined}
        >
            {children}
        </Link>
    );
}

const MainPanelHeader = ({ panelType, panelName }) => {
    const { setToggleSidebar } = useContext(GlobalStateContext);
    const [notificationModal, setNotificationModal] = useState(false);
    const { i18n, t } = useTranslation();
    const location = useLocation();
    const organList = useSideBarList();
    const userList = useUserSideBarList();

    const fromRoute = useMemo(
        () => resolveHeaderCrumb(location.pathname, organList, userList, t),
        [location.pathname, organList, userList, t]
    );

    const typeLabel = fromRoute.panelType || panelType || "";
    const nameLabel = fromRoute.panelName || panelName || "";
    const panelHref = fromRoute.panelHref || "";
    const pageHref = fromRoute.pageHref || "";
    const currentPath = normalizePath(location.pathname);

    useEffect(() => {
        document.title = nameLabel ? `${APP_TITLE} | ${nameLabel}` : APP_TITLE;
        return () => {
            document.title = APP_TITLE;
        };
    }, [nameLabel]);

    const showNotificationModal = () => {
        setNotificationModal(!notificationModal);
    };
    const openSidebar = () => {
        document.body.classList.add("no_overflow");
        setToggleSidebar(true);
    };

    const changeLanguageHandle = (language) => {
        i18n.changeLanguage(language);
        localStorage.setItem("activeLanguage", language);
    };

    return (
        <div className="panel_header main_box">
            <Image
                src={hambergerIcon}
                className="d-block d-lg-none hamberger_icon"
                alt="open sidebar"
                onClick={openSidebar}
            />
            <nav className="bread_crumb" aria-label={APP_TITLE}>
                {typeLabel ? (
                    <CrumbLink
                        to={panelHref}
                        className="item main"
                        current={
                            panelHref &&
                            normalizePath(panelHref) === currentPath
                        }
                    >
                        {typeLabel}
                    </CrumbLink>
                ) : null}
                {typeLabel && nameLabel ? (
                    <span className="dash" aria-hidden="true">
                        /
                    </span>
                ) : null}
                {nameLabel ? (
                    <CrumbLink
                        to={pageHref}
                        className="item"
                        current={
                            pageHref && normalizePath(pageHref) === currentPath
                        }
                    >
                        {nameLabel}
                    </CrumbLink>
                ) : null}
            </nav>
            <div className="left_box">
                <div className="notification_box has_new">
                    <div className="language-buttons">
                        <button
                            onClick={() => changeLanguageHandle("fa")}
                            className={
                                "language-button fa" +
                                (i18n.language === "fa" ? " selected" : "")
                            }
                        >
                            فا
                        </button>
                        <button
                            onClick={() => changeLanguageHandle("en")}
                            className={
                                "language-button en" +
                                (i18n.language === "en" ? " selected" : "")
                            }
                        >
                            En
                        </button>
                    </div>
                    <button
                        type="button"
                        className="notification-center-trigger"
                        aria-label={t("incentives.notifications.open")}
                        onClick={showNotificationModal}
                    >
                        <Notification size={20} aria-hidden="true" />
                    </button>
                </div>
            </div>
            <NotificationsCenter
                show={notificationModal}
                onHide={() => setNotificationModal(false)}
            />
        </div>
    );
};

export default MainPanelHeader;
